import { Size } from '../utils/common/size';
import { SizeService } from '../utils/common/size.service';
var ElementSizeHelper = /** @class */ (function () {
    function ElementSizeHelper(diagram) {
        this.diagram = diagram;
        this._sizeService = new SizeService();
    }
    ElementSizeHelper.prototype.setDataProperty = function (dataArray, type, value) {
        this.diagram.model.setDataProperty(dataArray, type, value);
    };
    ElementSizeHelper.prototype.getWidth = function (part) {
        var data = part.data;
        var category = data.category;
        if (['Rectangle', 'Ellipse'].indexOf(category) >= 0) {
            if (data.hasOwnProperty('width') && data.width > 0) {
                return Number(data.width);
            }
            return part.actualBounds.width;
        }
        else if (['Sector'].indexOf(category) >= 0) {
            return data.radius * 2;
        }
        else {
            if (data.hasOwnProperty('size') && this._sizeService.isValidSizeStr(data.size)) {
                return Number(data.size.split(' ')[0]);
            }
            if (data.category === 'Pipe') {
                return part.routeBounds.width;
            }
            return part.actualBounds.width;
        }
    };
    ElementSizeHelper.prototype.setWidth = function (part, width) {
        var data = part.data;
        width = Number(width);
        var category = data.category;
        if (['Pipe', 'Table'].indexOf(category) >= 0) {
            return;
        }
        if (['Rectangle', 'Ellipse'].indexOf(category) >= 0) {
            this.setDataProperty(part.data, 'width', width);
        }
        else if (['Sector'].indexOf(category) >= 0) {
            this.setDataProperty(part.data, 'radius', width / 2);
        }
        else {
            if (part.data.hasOwnProperty('size') && this._sizeService.isValidSizeStr(part.data.size)) {
                var size = this._sizeService.parse(part.data.size);
                size.width = width;
                if (['Meter', 'RingGraph'].indexOf(data.category) >= 0) {
                    size.height = width;
                }
                this.setDataProperty(part.data, 'size', size.toString());
            }
            else {
                this.setDataProperty(part.data, 'size', new Size(width, part.actualBounds.height).toString());
            }
        }
    };
    ElementSizeHelper.prototype.setHeight = function (part, height) {
        var data = part.data;
        height = Number(height);
        var category = data.category;
        if (['Pipe', 'Table'].indexOf(category) >= 0) {
            return;
        }
        if (['Rectangle', 'Ellipse'].indexOf(category) >= 0) {
            this.setDataProperty(part.data, 'height', height);
        }
        else if (['Sector'].indexOf(category) >= 0) {
            this.setDataProperty(part.data, 'radius', height / 2);
        }
        else {
            if (part.data.hasOwnProperty('size') && this._sizeService.isValidSizeStr(part.data.size)) {
                var size = this._sizeService.parse(part.data.size);
                size.height = height;
                if (['Meter', 'RingGraph'].indexOf(data.category) >= 0) {
                    size.width = height;
                }
                this.setDataProperty(part.data, 'size', size.toString());
            }
            else {
                this.setDataProperty(part.data, 'size', new Size(part.actualBounds.width, height).toString());
            }
        }
    };
    ElementSizeHelper.prototype.getHeight = function (part) {
        var data = part.data;
        var category = data.category;
        if (['Rectangle', 'Ellipse'].indexOf(category) >= 0) {
            if (data.hasOwnProperty('height') && data.height > 0) {
                return Number(data.height);
            }
            return part.actualBounds.height;
        }
        else if (['Sector'].indexOf(category) >= 0) {
            return data.radius * 2;
        }
        else {
            if (data.hasOwnProperty('size') && this._sizeService.isValidSizeStr(data.size)) {
                return Number(data.size.split(' ')[1]);
            }
            if (data.category === 'Pipe') {
                return part.routeBounds.height;
            }
            return part.actualBounds.height;
        }
    };
    ElementSizeHelper.prototype.setSize = function (part, width, height) {
        var category = part.data.category;
        this.setWidth(part, width);
        if (['Sector', 'Meter', 'RingGraph', 'Table'].indexOf(category) < 0) {
            this.setHeight(part, height);
        }
    };
    return ElementSizeHelper;
}());
export { ElementSizeHelper };
